import React from 'react';

/**
 * A simple text section with a big uk-text-lead paragraph and a tiny normal paragraph.
 * Optionally centers text if props.centered is true.
 * @param {*} props
 * @returns
 */
function BigTinyIntroSection(props)
{
    var isCentered = props.centered === true;
    var containerClass = isCentered ? "uk-container uk-text-center" : "uk-container";

    return (
        <div>
            <section className="uk-section uk-section-default">
                <div className={containerClass}>
                    <p className="uk-text-lead">
                        {props.Big}
                    </p>
                    <p>
                        {props.Tiny}
                    </p>
                </div>
            </section>
        </div>
    );
}

export default BigTinyIntroSection;